import { Theme } from "../../constants";

export default {

    checkboxWLabelContainer: {
        display: "flex",
        alignItems: "center"
    },

    checkboxLabel: {
        marginLeft: "15px"
    },

    requiredStarLabel: {
        color: Theme.ERROR_TEXT,
    }

}